import planData from "../components/plans.json";

/** Preferred display order for subscription picker plans. */
const PLAN_ORDER = ["Solo", "Team"];

/**
 * Plans marked for the subscription picker, as { priceId, ...planFields }.
 */
export function getSubscriptionPickerPlans() {
  return Object.entries(planData)
    .filter(([, plan]) => plan.showOnSubscriptionPicker === true)
    .map(([priceId, plan]) => ({ priceId, ...plan }));
}

/**
 * Picker plans for a billing interval ("month" | "year"), sorted Solo then Team.
 */
export function getPickerPlansForInterval(interval) {
  return getSubscriptionPickerPlans()
    .filter((plan) => plan.interval === interval)
    .sort(
      (a, b) =>
        PLAN_ORDER.indexOf(a.planName) - PLAN_ORDER.indexOf(b.planName)
    );
}

/**
 * Format unit_amount (cents) for display, e.g. "$18" or "$180".
 */
export function formatPlanPrice(unitAmount, currency = "usd") {
  if (unitAmount == null) return "";
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: (currency || "usd").toUpperCase(),
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(unitAmount / 100);
  } catch {
    return `$${(unitAmount / 100).toFixed(0)}`;
  }
}
